export default __webpack_public_path__ + "static/media/Snd4.6aa7da8e.mp3";